module.exports = __webpack_public_path__ + "static/media/ArchitectIcon.37ff194c.svg";